<template>
    <div>
        <Heading type="h3">{{ __('admin::labels.property_data') }}</Heading>

        <FormGroup
            v-for="(column, columnKey) in columns"
            :key="columnKey"
            :label="column.name"
        >
            <Component
                :is="column.component"
                v-model="proxyModelValue[columnKey]"
                :required="false"
                :disabled="readOnly"
            />
        </FormGroup>
    </div>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";
import Input from "@/Components/Input.vue";
import FileLinkInput from "@/Components/FileLinkInput.vue";
import Heading from "@/Components/Heading.vue";

export default {
    components: {
        Heading,
        FormGroup,
        Input,
        FileLinkInput,
    },
    props: {
        columns: Object,
        modelValue: Object,
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            proxyModelValue: this.modelValue,
        };
    },
    watch: {
        proxyModelValue: {
            handler: function (newValue) {
                this.$emit('update:modelValue', newValue);
            },
            deep: true,
        },
    }
}
</script>
